<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :confirm="confirm"
    :close="close"
    confirmButtonTitle="저장"
    :confirm-button-title="`${this.paymentNotice ? '수정' : '등록'}`"
    :modal-title="`${this.paymentNotice ? '결제 안내사항 수정' : '결제 안내사항 등록'}`"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form-floating-label>
            공지사항 노출 여부
          </b-form-floating-label>
          <b-form-radio-group
            v-model="publishStatus"
            :options="publishOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-floating-label>
            제목
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="title"
            type="text"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-form-floating-label>
          내용
        </b-form-floating-label>
        <div class="main-container w-100">
          <div class="editor-container editor-container_classic-editor" ref="editorContainerElement">
            <div class="editor-container__editor">
              <div ref="editorElement" class="ck-content">
                <ckeditor v-if="isLayoutReady" v-model="config.initialData" :editor="editor" :config="config" />
              </div>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-2">
        <b-col>
          <b-form-floating-label>메모</b-form-floating-label>
          <b-form-textarea
            v-model="memo"
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";
import 'ckeditor5/ckeditor5.css';
import {
  AccessibilityHelp,
  Alignment,
  Autoformat,
  Autosave,
  BalloonToolbar,
  Base64UploadAdapter,
  BlockQuote,
  Bold,
  ClassicEditor,
  CloudServices,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  HorizontalLine,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  ListProperties,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  PastePlainText,
  SelectAll,
  SimpleUploadAdapter,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TodoList,
  Underline,
  Undo
} from 'ckeditor5';
import translations from 'ckeditor5/translations/ko.js';

export default {
  name: "PaymentNoticeModal",
  components: {AdminModal},
  props: ['isOpen', 'paymentNotice', 'reload', 'close'],
  data() {
    return {
      id : null,
      title : "",
      memo : "",
      isLayoutReady: false,
      config: {
        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            'lineHeight', // 행간 추가
            'letterSpacing', // 자간 추가
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'horizontalLine',
            'link',
            'insertTable',
            'blockQuote',
            '|',
            'special',
            'alignment',
            '|',
            'bulletedList',
            'todoList',
            'outdent',
            'indent',
            'lineHeight'
          ],
          shouldNotGroupWhenFull: true
        },
        plugins: [
          PasteFromOffice,
          PastePlainText,
          AccessibilityHelp,
          Alignment,
          Autoformat,
          Autosave,
          BalloonToolbar,
          Base64UploadAdapter,
          BlockQuote,
          Bold,
          CloudServices,
          Essentials,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          Heading,
          Highlight,
          HorizontalLine,
          Indent,
          IndentBlock,
          Italic,
          Link,
          List,
          ListProperties,
          MediaEmbed,
          Paragraph,
          PasteFromOffice,
          SelectAll,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline,
          Undo,
          SimpleUploadAdapter
        ],
        balloonToolbar: [ 'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor', 'bold', 'italic', 'lineHeight', '|', 'link', '|', 'bulletedList', 'numberedList'],
        fontFamily: {
          supportAllValues: true
        },
        fontSize: {
          options: [
            { title: '10px', model: '10px' },
            { title: '12px', model: '12px' },
            { title: '14px', model: '14px' },
            { title: 'Default', model: '16px' },
            { title: '18px', model: '18px' },
            { title: '20px', model: '20px' },
            { title: '22px', model: '22px' },
            { title: '24px', model: '24px' },
            { title: '32px', model: '32px' },
            { title: '36px', model: '36px' },
            { title: '40px', model: '40px' },
            { title: '44px', model: '44px' },
            { title: '48px', model: '48px' },
            { title: '50px', model: '50px' },
            { title: '54px', model: '54px' },
            { title: '58px', model: '58px' }
          ],
          supportAllValues: true
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4'
            },
            {
              model: 'heading5',
              view: 'h5',
              title: 'Heading 5',
              class: 'ck-heading_heading5'
            },
            {
              model: 'heading6',
              view: 'h6',
              title: 'Heading 6',
              class: 'ck-heading_heading6'
            },
          ]
        },
        initialData: "",
        language: 'ko',
        link: {
          addTargetToExternalLinks: true,
          defaultProtocol: 'https://',
          decorators: {
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            }
          }
        },
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        },
        placeholder: 'Type or paste your content here!',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
        },
        translations: [translations]
      },
      editor: ClassicEditor,
      publishStatus: "UNPUBLISHED",
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ],
    }
  },
  mounted() {
    console.log('paymentNotice', this.paymentNotice)
    if (this.paymentNotice) {
      this.id = this.paymentNotice.id
      this.title = this.paymentNotice.title
      this.config.initialData = this.paymentNotice.content
      this.publishStatus = this.paymentNotice.status
      this.memo = this.paymentNotice.memo
    }

    this.isLayoutReady = true;
  },
  methods: {
    confirm() {
      if (this.id) {
        this.update()
      } else {
        this.save()
      }
    },
    update() {
      if (this.publishStatus === 'PUBLISHED') {
        this.$store.dispatch('modal/openModal', {
          type: 'warning',
          title: '공지사항 노출 변경',
          html: '공지사항 노출을 선택할 경우 기존 노출 공지사항은 비노출 됩니다.',
          confirm: () => {
            this.submitUpdate(); // 확인 버튼 클릭 시 실행
          }
        });
      } else {
        this.submitUpdate(); // 확인 없이 바로 실행
      }
    },
    submitUpdate() {
      api.paymentNotice.update({
        id: this.id,
        title: this.title,
        status: this.publishStatus,
        content:  this.config.initialData,
        memo: this.memo
      }, _ => {
        this.reload()
        this.close()
      })
    },
    save() {
      if (this.publishStatus === 'PUBLISHED') {
        this.$store.dispatch('modal/openModal', {
          type: 'warning',
          title: '공지사항 노출 변경',
          html: '공지사항 노출을 선택할 경우 기존 노출 공지사항은 비노출 됩니다.',
          confirm: () => {
            this.submitSave(); // 확인 버튼 클릭 시 실행
          }
        });
      } else {
        this.submitSave(); // 확인 없이 바로 실행
      }
    },
    submitSave() {
      api.paymentNotice.save({
        title: this.title,
        status: this.publishStatus,
        content:  this.config.initialData,
        memo: this.memo
      }, _ => {
        this.reload()
        this.close()
      })
    },
  }
}
</script>

<style scoped>
:deep(.ck-editor__editable_inline) {
  min-height: 400px;
}

/* 글씨 크기 드롭다운 고정 높이 및 스크롤 (일반 툴바) */
:deep(.ck-dropdown__panel) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

/* 글씨 크기 드롭다운 고정 높이 및 스크롤 (balloon toolbar) */
:deep(.ck-balloon-panel .ck-dropdown__panel) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

/* 글씨 크기 드롭다운 내부 리스트 고정 높이 및 스크롤 */
:deep(.ck-dropdown__panel .ck-list),
:deep(.ck-balloon-panel .ck-dropdown__panel .ck-list) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

/* 글씨 크기 선택 드롭다운의 모든 항목을 16px로 고정 */
:deep(.ck-dropdown__panel .ck-list__item),
:deep(.ck-balloon-panel .ck-dropdown__panel .ck-list__item) {
  font-size: 16px !important;
}

/* 글씨 크기 선택 드롭다운의 텍스트를 16px로 고정 */
:deep(.ck-dropdown__panel .ck-list__item .ck-button__label),
:deep(.ck-balloon-panel .ck-dropdown__panel .ck-list__item .ck-button__label) {
  font-size: 16px !important;
}

/* balloon toolbar 내부의 모든 드롭다운 패널 */
:deep(.ck-balloon-panel) {
  z-index: 9999;
}

:deep(.ck-balloon-panel .ck-dropdown__panel) {
  max-height: 200px !important;
  overflow-y: auto !important;
}
</style>